import { render, staticRenderFns } from "./InternetAuthentication.vue?vue&type=template&id=5f27edbd&scoped=true"
import script from "./InternetAuthentication.vue?vue&type=script&lang=js"
export * from "./InternetAuthentication.vue?vue&type=script&lang=js"
import style0 from "./InternetAuthentication.vue?vue&type=style&index=0&id=5f27edbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27edbd",
  null
  
)

export default component.exports